import React, { createContext, FC, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { checkForUndefined, getData } from '../Services/Util';

interface AuthContextProps {
  auth: any;
  setAuth: (value: any) => void;
  persist: boolean;
  setPersist: (persist: boolean) => void;
}

const AuthContext = createContext<AuthContextProps>({} as AuthContextProps);

export const AuthProvider: FC<{ children: React.ReactNode }> = ({ children }) => {
  const [auth, setAuth] = useState<any>({});
  const [persist, setPersist] = useState<boolean>(false);
  const navigate = useNavigate();

  useEffect(() => {
    const checkAuthAndRedirect = async () => {
      try {
        const [DBType, userData] = await Promise.all([
          getData('DBType'),
          getData('userData'),
        ]);

        const allExist =
          checkForUndefined(DBType) &&
          checkForUndefined(userData);

        if (!allExist || userData?.isLogin !== true) {
          navigate('/', { replace: true });
        }
      } catch (error) {
        console.error('Auth check failed:', error);
        navigate('/', { replace: true });
      }
    };

    checkAuthAndRedirect();
  }, [navigate]);

  return (
    <AuthContext.Provider value={{ auth, setAuth, persist, setPersist }}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContext;
